import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: 
        0px 20px 50px -20px rgba(0, 0, 0, 0.1),
        0px 0px 40px 0px rgba(0, 0, 0, 0.1),
        0px 0px 50px 0px rgba(0, 0, 0, 0.05);
`;

const Card6 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props.backgroundColor || (props.content && props.content.backgroundColor);
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);

    // Separate items by type
    const richTextItems = items?.filter(item => item.__typename === "ContentfulRichText") || [];
    const mediaItems = items?.filter(item => item.__typename === "ContentfulMedia") || [];

    // Get the first rich text item
    const firstRichText = richTextItems[0];
    // Get the remaining rich text items
    const remainingRichTexts = richTextItems.slice(1);

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            className={`card1 flex-1 flex  justify-start  ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {items.length > 0 && (
                <div className={`card6__content [&>div:first-child]:bg-gradient-card-header lg:[&>div:first-child]:px-[48px] lg:[&>div:first-child]:py-[32px] [&>div:first-child]:p-[24px] [&>div:first-child]:rounded-top_48 [&>div:not(:first-child)]:py-[24px] [&>div:not(:first-child)]:px-[32px] [&>div:first-child]:max-w-[100%] w-full`}>
                    {/* First rich text item */}
                    {firstRichText && (
                        <MapTo key={firstRichText.id} items={firstRichText} />
                    )}

                    {/* Grid container for media and remaining rich texts */}
                    <div className="flex lg:flex-row flex-col lg:items-start items-center gap-[32px] lg:px-[40px] px-[24px] py-[32px] break-words">
                        {/* Media item */}
                        {mediaItems.length > 0 && (
                            <div className="card6__inner max-w-[93px] w-full lg:max-w-max_content">
                                <MapTo key={mediaItems[0].id} items={mediaItems[0]} />
                            </div>
                        )}

                        {/* Remaining rich text items */}
                        <div className="space-y-4" style={{ wordBreak: 'break-word' }}>
                            {remainingRichTexts.map((item) => (
                                <MapTo key={item.id} items={item} />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </StyledContainer>
    );
};

export default Card6; 